import styled from "@emotion/styled";

export const CustomQuoteErrorBoxWrapper = styled.div(({ theme }) => ({
	width: "100%",
	height: "100vh",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	backgroundColor: theme.project.colors.backgroundColors.main
}));

export const CustomQuoteDetailPageWrapper = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column"
}));

export const CustomQuoteDetailPageTop = styled.div(({ theme }) => ({
	backgroundColor: "white",
	padding: "20px",
	display: "flex",
	flexDirection: "column",
	gap: "16px"
}));

export const CustomQuoteDetailContent = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	padding: "16px",
	gap: "8px",
	backgroundColor: theme.palette.grey[100],
	color: theme.project.colors.fontColors.main
}));

export const CustomQuoteDetailNav = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const CustomQuoteDetailNavItem = styled.div(({ theme }) => ({
	flexDirection: "column",
	justifyContent: "space-around",
	display: "flex",
	gap: "8px",
	h2: {
		...theme.project.typography.heading.h4,
		color: theme.project.colors.fontColors.main,
		margin: 0
	}
}));
